export const loop = {
  input: {
    elements: "Elements to iterate"
  },
  output: {
    element: "Iteration element",
    key: "Iteration key"
  }
};
